<div>
  <div class="modal-header">
    <h4 class="modal-title">Оставить заявку</h4>
    <button type="button" class="close text-danger" aria-label="Close" (click)="activeModal.close('Cross click')">
      <span><span class="dark-color"><i class="fa fa-times" aria-hidden="true"></i></span></span>
    </button>
  </div>
  <form [formGroup]="orderForm" (ngSubmit)="order()">
  <div class="modal-body">
      <div class="form-group">
        <label for="name">Как вас зовут? </label>
        <input type="text" class="form-control" formControlName="name" id="name" aria-describedby="emailHelp" placeholder="Введите имя*">
        <div class="text-danger"
             *ngIf="orderForm.controls['name'].invalid && orderForm.controls['name'].touched">
              Обязательное поле
        </div>
      </div>
      <div class="form-group" >
        <label for="number">Номер телефона </label>
        <input type="text" class="form-control" id="number" prefix="+7" mask="(000) 000 00 00"  formControlName="number" aria-describedby="emailHelp" placeholder="Введите номер телефона*">
        <div class="text-danger"
             *ngIf="orderForm.controls['number'].invalid && orderForm.controls['number'].touched">
          Обязательное поле
        </div>
      </div>
      <div class="form-group">
        <label for="email">Электронная почта</label>
        <input type="text" class="form-control" id="email" formControlName="email" placeholder="Введите электронную почту*">
        <div class="text-danger"
             *ngIf="orderForm.controls['email'].invalid && orderForm.controls['email'].touched">
          <div *ngIf="f.email.errors.required">Обязательное поле</div>
          <div *ngIf="f.email.errors.email">Введите корректный email</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="email">Адрес</label>
            <input type="text" class="form-control" id="adress" formControlName="adress" placeholder="Введите адрес*">
            <div class="text-danger"
                 *ngIf="orderForm.controls['adress'].invalid && orderForm.controls['adress'].touched">
              <div *ngIf="f.adress.errors.required">Обязательное поле</div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="email">Номер дома</label>
            <input type="text" class="form-control" id="home" formControlName="home" placeholder="Введите номер дома*">
            <div class="text-danger"
                 *ngIf="orderForm.controls['home'].invalid && orderForm.controls['home'].touched">
              <div *ngIf="f.home.errors.required">Обязательное поле</div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="email">Номер квартиры</label>
            <input type="text" class="form-control" id="apartment" formControlName="apartment" placeholder="Введите номер квартиры*">
            <div class="text-danger"
                 *ngIf="orderForm.controls['apartment'].invalid && orderForm.controls['apartment'].touched">
              <div *ngIf="f.apartment.errors.required">Обязательное поле</div>
            </div>
          </div>
        </div>
      </div>
      <small id="emailHelp" class="form-text text-muted">Подключим за 24 часа</small>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" [disabled]="orderForm.invalid">Отправить заявку</button>
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Закрыть</button>
  </div>
  </form>
</div>
